import { render, staticRenderFns } from "./RelationTile.vue?vue&type=template&id=330b0560&"
import script from "./RelationTile.vue?vue&type=script&lang=js&"
export * from "./RelationTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports